<template>
    <div class="container-fluid">
        <Breadcrumb title="Create new PMTA Campaign" v-bind:button-show="false" v-show="!id"></Breadcrumb>
        <Breadcrumb title="Edit PMTA Campaign" v-bind:button-show="false" v-show="id"></Breadcrumb>

        <div class="row" style="position: relative">
            <div class="col-12 row-preloader">
                <Preloader v-bind:class="{preloader: loading}" v-show="loading"></Preloader>
            </div>
            <div class="col-12" v-show="!loading">
                <div class="card">
                    <div class="card-body">
                        <CampaignForm @setLoading="setLoading"></CampaignForm>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header">
                        <h5>Last 10 Campaigns:</h5>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table table-sm">
                                <thead>
                                <tr class="bg-info text-white">
                                    <th class="pl-3">Status</th>
                                    <th>Start Date</th>
                                    <th>Name</th>
                                    <th>Email List</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-if="loadingHistory">
                                    <td class="pl-3"><i class="fas fa-spinner fa-spin"></i></td>
                                    <td class="pl-3"><i class="fas fa-spinner fa-spin"></i></td>
                                    <td class="pl-3"><i class="fas fa-spinner fa-spin"></i></td>
                                    <td class="pl-3"><i class="fas fa-spinner fa-spin"></i></td>
                                </tr>
                                <tr v-for="(campaign, index) in campaignHistory" :key="index">
                                    <td class="align-middle">
                                                <span class="label"
                                                      v-bind:class="[campaignStatus.label[campaign.status]]">
                                                    {{campaignStatus.value[campaign.status]}}
                                                </span>
                                    </td>
                                    <td class="align-middle">
                                        {{campaign.startDate ? moment.utc(campaign.startDate.toString()).format('YYYY-M-D H:mm') : "-"}}
                                    </td>
                                    <td class="align-middle">
                                        {{campaign.name}}
                                    </td>
                                    <td class="align-middle">{{campaign.emailList.name}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import Preloader from '../components/Preloader';
    import CampaignForm from './forms/PmtaCampaignForm';
    import Breadcrumb from '../components/Breadcrumb';
    import {CampaignStatus} from '../constants';
    import CampaignService from '../services/PmtaCampaignService';
    import AuthService from "../services/AuthService";

    export default {
        name: 'PmtaCampaign',
        props: ['id'],
        components: {
            Preloader, CampaignForm, Breadcrumb
        },
        data() {
            return {
                loading: false,
                loadingHistory: false,
                campaignStatus: CampaignStatus,
                campaignHistory: [],
                userId: AuthService.tokenDecode(AuthService.getToken()).id,
            }
        },
        mounted() {
            this.getHistory();
        },
        methods: {
            setLoading(value) {
                this.loading = value
            },
            getHistory: function () {
                this.loadingHistory = true;
                CampaignService.getCampaigns(1, 10, this.userId).then(response => {
                    this.campaignHistory = response.data['hydra:member'];
                    this.loadingHistory = false;
                });
            },
        }
    }
</script>

<style scoped>

</style>
